import { render, staticRenderFns } from "./CallTemplate.vue?vue&type=template&id=4c9c5880&"
import script from "./CallTemplate.vue?vue&type=script&lang=ts&"
export * from "./CallTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports